import BigNumber from "bignumber.js";

export function plus(...numbers) {
  const length = numbers.length;
  if (!length) return 0;
  if (length === 1) return numbers[0];

  numbers[0] = +numbers[0] || 0;
  const result = numbers.reduce((total, currentValue) => {
    total = new BigNumber(total);
    return total.plus(+currentValue || 0);
  });

  return +`${result}`;
}

export function minus(...numbers) {
  const length = numbers.length;
  if (!length) return 0;
  if (length === 1) return numbers[0];

  numbers[0] = +numbers[0] || 0;
  const result = numbers.reduce((total, currentValue) => {
    total = new BigNumber(total);
    return total.minus(+currentValue || 0);
  });

  return +`${result}`;
}

export function multipliedBy(...numbers) {
  const length = numbers.length;
  if (!length) return 0;
  if (length === 1) return numbers[0];
  if (numbers.includes('0') || numbers.includes(0) || numbers.includes('')) return 0;// 包含0

  numbers[0] = +numbers[0] || 0;
  const result = numbers.reduce((total, currentValue) => {
    total = new BigNumber(total);
    return total.multipliedBy(+currentValue || 0);
  });

  return +`${result}`;
}

export function dividedBy(...numbers) {
  const length = numbers.length;
  if (!length || !numbers[0]) return 0;
  if (length === 1) return numbers[0];
  if (numbers.includes('0') || numbers.includes(0) || numbers.includes('')) return 0;// 包含0

  numbers[0] = +numbers[0] || 0;
  const result = numbers.reduce((total, currentValue) => {
    total = new BigNumber(total);
    return total.dividedBy(+currentValue || 0);
  });

  return +`${result}`;
}

export function decimalPlaces(number, decimalPlaces = 2) {
  number = new BigNumber(number);
  return +`${number.decimalPlaces(decimalPlaces)}`;
}

// 将以元为单位的数字转换为以分为单位的数字，并向下取整
export function toCent(number) {
  return Math.floor(multipliedBy(number, 100));
}

// 将以分为单位的数字转换为以元为单位的数据，并保留两位小数
export function toYuan(number) {
  return decimalPlaces(dividedBy(number, 100));
}

const MONEY_FORMAT = new Intl.NumberFormat('zh-CN', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});
const MONEY_FORMAT_WITH_CENTS = new Intl.NumberFormat('zh-CN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// 将“分”格式化为中国人习惯的金额：
// 1 万以下：3,980.00；1 万 ~ 1 亿：1.23万；1 亿以上：1.09亿
export function formatChineseMoney(cents) {
  const value = Number(cents);
  if (!Number.isFinite(value)) return '-';

  const yuan = value / 100;
  const absYuan = Math.abs(yuan);

  if (absYuan >= 100000000) {
    return `${MONEY_FORMAT.format(yuan / 100000000)}亿`;
  }
  if (absYuan >= 10000) {
    return `${MONEY_FORMAT.format(yuan / 10000)}万`;
  }
  return MONEY_FORMAT_WITH_CENTS.format(yuan);
}

// 将以毫秒为单位的数字转换为以秒为单位的数字，并向下取整
export function toSecond(number) {
  return Math.floor(dividedBy(number, 1000));
}

// 将以秒为单位的数字转换为以毫秒为单位的数字，并向下取整
export function toMillisecond(number) {
  return Math.floor(multipliedBy(number, 1000));
}

export function getTableSummaries(param) {
  const { columns, data } = param;
  const sums = [];

  columns.forEach((column, index) => {
    if (index === 0) return sums[index] = this.summaryTitle || '合计';
    if (column.type === 'isNotSummary') return;

    sums[index] = 0;
    const { property } = column;
    const list = data.filter(item => !item.isNotSummary);

    for (let item of list) {
      const num = +item[property];
      if (isNaN(num)) return sums[index] = '';

      sums[index] = plus(sums[index], num);
    }

    if (column.type === 'money') return sums[index] = dividedBy(sums[index], 100);

    if (column.type === 'average' && index === sums.length - 1) {
      if (data[0] && data[0].hasOwnProperty('total_attendance') && data[0].hasOwnProperty('group_course_count')) {
        let totalAttendance = 0;
        let groupCourseCount = 0;
        for (let item of list) {
          totalAttendance = plus(totalAttendance, item.total_attendance);
          groupCourseCount = plus(groupCourseCount, item.group_course_count);
        }
        sums[index] = dividedBy(totalAttendance, groupCourseCount);
        sums[index] = decimalPlaces(sums[index]);
      } else {
        sums[index] = dividedBy(sums[index], list.length);
        sums[index] = decimalPlaces(sums[index]);
      }
    }
  });

  return sums;
}
